import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { ResourceGroups } from './components/resource-groups';
import { MarkdownRenderer } from '@/components/shared/markdown-renderer';
import { NotFound } from '@/components/shared/not-found';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { ResourceTypes } from '@/data/learning-path/interfaces';
import { useShowPath } from '@/data/learning-path/path';
import { useSetTitle } from '@/hooks/use-set-title';

export const ShowPath = () => {
  const navigate = useNavigate();
  const { pathId } = useParams();
  const { path, isFetching } = useShowPath({ pathId: pathId ?? '' });
  useSetTitle(path?.title ?? '');
  const notFound = !path && !isFetching;

  if (isFetching) return <PageSkeleton />;

  return (
    <PageContainer>
      <Box maxWidth={notFound ? '100%' : 'md'}>
        <PageHeader
          title={path?.title}
          description={path?.description}
          backNavigationText="Trilhas"
          handleBackNavigation={() => navigate('/trilhas')}
        />

        {notFound && (
          <Box py={4}>
            <NotFound
              title="Trilha não encontrada."
              description="Esta trilha não está disponível no momento. Que tal explorar outras trilhas?"
              buttonText="Ir para trilhas"
              href="/trilhas"
              centered
            />
          </Box>
        )}

        {!isFetching && path && (
          <Box>
            {path?.contents?.map((item, index) => {
              const renderMarkdown =
                item.type === ResourceTypes.Text && item.content?.body;
              const resourceGroup =
                item.type === ResourceTypes.ResourceGroup &&
                item.content?.resource_groups;

              if (renderMarkdown) {
                return (
                  <Box key={item.id} mt={index !== 0 ? 6 : 0}>
                    <MarkdownRenderer
                      markdown={item.content.body}
                      data-testid="MarkdownRenderer"
                    />
                  </Box>
                );
              }

              if (resourceGroup) {
                return (
                  <Box my={3} key={item.id}>
                    <ResourceGroups
                      key={item.id}
                      resourceGroup={item.content.resource_groups}
                    />
                  </Box>
                );
              }

              return null;
            })}
          </Box>
        )}
      </Box>
    </PageContainer>
  );
};
